<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
  <div id="antrag_vertragsdaten">
    <div class="row">
      <div class="col col-xs-12 col-sm-12" *ngIf="!showLaufzeit; else laufzeitContent">
        <ng-template *ngTemplateOutlet="beginndatumTemplate"></ng-template>
      </div>
      <ng-template #laufzeitContent>
        <div class="col col-xs-12 col-sm-6">
          <ng-template *ngTemplateOutlet="beginndatumTemplate"></ng-template>
        </div>
        <div class="col col-xs-12 col-sm-6">
          <div class="input_radio">
            <app-label [control]="laufzeit" for="laufzeit">Laufzeit:</app-label>
            <mat-radio-group id="laufzeit" formControlName="laufzeit">
              <mat-radio-button *ngFor="let laufzeit of laufzeiten | keyvalue : returnZero" [value]="laufzeit.key">{{ laufzeit.value }}</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="laufzeit.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
          </div>
        </div>
      </ng-template>
      <ng-template #beginndatumTemplate>
        <div class="input">
          <div class="text_info">
            <app-label [control]="beginndatum" class="input-date-picker__label" for="beginndatum">{{ expertMode ? 'Beginndatum:' : 'Wann soll der Vertragsbeginn sein?' }}</app-label>
          </div>
          <mat-form-field>
            <input matInput id="beginndatum" [matDatepicker]="beginndatumPicker" placeholder="TT.MM.JJJJ" formControlName="beginndatum">
            <mat-datepicker #beginndatumPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </ng-template>
      <div class="col col-xs-12 col-sm-12" *ngIf="showHauptfaelligkeit">
        <div class="row">
          <div class="col col-xs-12 col-sm-6">
            <div class="input">
              <app-label [control]="hauptfaelligkeitTag" class="input__label" for="hauptfaelligkeitTag">Hauptfälligkeit Tag:</app-label>
              <mat-form-field>
                <mat-select id="hauptfaelligkeitTag" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="hauptfaelligkeitTag">
                  <mat-option *ngFor="let hauptfaelligkeitTag of hauptfaelligkeitTage | keyvalue" [value]="hauptfaelligkeitTag.key">{{ hauptfaelligkeitTag.value }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-6">
            <app-label [control]="hauptfaelligkeitMonat" class="custom-select__label" for="hauptfaelligkeitMonat">Hauptfälligkeit Monat:</app-label>
            <mat-form-field>
              <mat-select id="hauptfaelligkeitMonat" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="hauptfaelligkeitMonat">
                <mat-option *ngFor="let hauptfaelligkeitMonat of hauptfaelligkeitMonate | keyvalue" [value]="hauptfaelligkeitMonat.key">{{ hauptfaelligkeitMonat.value }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-partner #_versicherungsnehmer [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="versicherungsnehmer" [privatperson]="privatperson" [versicherungsnehmer]="true" idprefix="antrag" [showEinzelunternehmen]="showEinzelunternehmen" [anredenPrivatperson]="anredenPrivatperson" [_geburtsdatum]="_geburtsdatum" [expertMode]="expertMode" (partnerChangedEvent)="partnerChanged()" [validateAlter]="validateAlter"></app-partner>
  <div class="col col-xs-12 col-sm-12">
    <div class="custom_select" *ngIf="showVersicherungsort">
      <app-label [control]="abweichenderVersicherungsort" class="custom-select__label" for="abweichenderVersicherungsort">Versicherungsort:</app-label>
      <mat-form-field>
        <mat-select id="abweichenderVersicherungsort" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" [formControl]="abweichenderVersicherungsort">
          <mat-option *ngFor="let v of versicherungsortSelect | keyvalue" [value]="v.key">{{ v.value }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="col col-xs-12 col-sm-12">
    <app-adresse #_versicherungsort [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="versicherungsort" title="Versicherungsort" idprefix="versicherungsort" [showGroup]="showVersicherungsortGroup"></app-adresse>
  </div>
  <div *ngIf="showWeitereWohneinheiten">
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <div class="input_radio">
          <app-label [control]="weitereWohneinheiten" for="weitereWohneinheiten">Wollen Sie eine weitere Wohneinheit angeben?</app-label>
          <mat-radio-group id="weitereWohneinheiten" formControlName="weitereWohneinheiten">
            <mat-radio-button value="ja">Ja</mat-radio-button>
            <mat-radio-button value="nein">Nein</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </div>
  <app-adresse #_zweiteWohneinheit [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="zweiteWohneinheit" title="Zweite Wohneinheit (prämienfrei)" idprefix="zweiteWohneinheit" [showGroup]="showWeitereWohneinheitenGroup"></app-adresse>
  <app-adresse #_dritteWohneinheit [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="dritteWohneinheit" title="Dritte Wohneinheit (prämienfrei)" idprefix="dritteWohneinheit" [showGroup]="showWeitereWohneinheitenGroup"></app-adresse>
  <div class="row">
    <div class="col col-xs-12 col-sm-12">
      <div class="input_radio">
        <app-label for="abweichendeZustelladresse" [control]="abweichendeZustelladresse">Abweichende Zustelladresse?</app-label>
        <mat-radio-group id="abweichendeZustelladresse" formControlName="abweichendeZustelladresse">
          <mat-radio-button value="ja">Ja</mat-radio-button>
          <mat-radio-button value="nein">Nein</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="abweichendeZustelladresse.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div class="input_radio" *ngIf="showAbweichendeZustelladresseArt">
        <app-label for="abweichendeZustelladresseArt" [control]="abweichendeZustelladresseArt">Art der abweichende Zustelladresse?</app-label>
        <mat-radio-group id="abweichendeZustelladresseArt" formControlName="abweichendeZustelladresseArt">
          <mat-radio-button [value]=1>Nur Adresse</mat-radio-button>
          <mat-radio-button [value]=2>Person und Adresse</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="abweichendeZustelladresseArt.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
      </div>
    </div>
  </div>
  <div *ngIf="showAbweichendeZustelladresseAdresseGroup" class="label-infotext mindestpraemie-infotext">Beachten Sie bitte, dass sämtliche Dokumente an diese Adresse verschickt werden. Es liegt in der Verantwortung des Versicherungsnehmers, sicherzugehen, dass an die Adresse zugestellt werden kann.</div>
  <app-adresse #_abweichendeZustelladresseAdresse [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="abweichendeZustelladresseAdresseGroup" idprefix="adweichendeZustelladresseAdresse" [required]="true" [showGroup]="showAbweichendeZustelladresseAdresseGroup"></app-adresse>
  <app-partner #_abweichendeZustelladressePerson [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="abweichendeZustelladressePersonGroup" [privatperson]="privatperson" idprefix="adweichendeZustelladressePerson" [showGroup]="showAbweichendeZustelladressePersonGroup" [showEinzelunternehmen]="showEinzelunternehmen" [anredenPrivatperson]="anredenPrivatperson" [expertMode]="expertMode"></app-partner>
  <div class="row">
    <div class="col col-xs-12 col-sm-12">
      <div class="input_radio">
        <app-label [control]="abweichenderPraemienzahler" for="abweichenderPraemienzahler">Abweichender Prämienzahler?</app-label>
        <mat-radio-group id="abweichenderPraemienzahler" formControlName="abweichenderPraemienzahler">
          <mat-radio-button value="ja">Ja</mat-radio-button>
          <mat-radio-button value="nein">Nein</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="abweichenderPraemienzahler.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col col-xs-12 col-sm-12">
      <div class="input_radio" *ngIf="showPraemienzahlerPersonenart">
        <mat-radio-group id="praemienzahlerPersonenArt" formControlName="praemienzahlerPersonenArt">
          <mat-radio-button *ngFor="let pa of personenArten | async" [value]="pa">{{ pa.Value }}</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="praemienzahlerPersonenArt.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
      </div>
    </div>
  </div>
  <app-partner #_praemienzahler [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="praemienzahler" [privatperson]="isPraemienzahlerPrivatperson" idprefix="praemienzahler" [showGroup]="showPraemienzahler" [showEinzelunternehmen]="isPraemienzahlerEinpersonenUnternehmen" [anredenPrivatperson]="anredenPrivatperson" [expertMode]="expertMode"></app-partner>
  <div class="mt-3" id="antrag_praemienzahlung">
    <h6>Prämienzahlung</h6>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <div class="input_radio">
          <div class="text_info">
            <app-label [control]="zahlungsweise" for="zahlungsweise">Zahlungsart:</app-label>
            <div class="info">
              <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('ZAHLUNGSARTINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
            </div>
          </div>
          <div class="label-infotext pb-3">Falls Sie eine ausländische Bankverbindung haben, wählen Sie bitte „Zahlschein“ und tragen Sie Ihre Bankdaten in der Zusammenfassung unter „Besondere Anmerkungen“ ein.</div>
          <mat-radio-group id="zahlungsweise" formControlName="zahlungsweise">
            <mat-radio-button *ngFor="let zahlungsweise of zahlungsweisen | keyvalue" [value]="zahlungsweise.key">{{ zahlungsweise.value }}</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="zahlungsweise.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="input" *ngIf="showIban">
          <app-label [control]="iban" class="input__label" for="iban">IBAN:</app-label>
          <mat-form-field>
            <input matInput id="iban" [value]="iban.value" formControlName="iban">
            <mat-error *ngIf="iban.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
            <mat-error *ngIf="iban.hasError('iban')">{{ 'INPUTINVALID' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="custom_select">
          <app-label [control]="zahlungsart" class="custom-select__label" for="zahlungsart">{{ expertMode ? 'Zahlungsweise' : 'In welchem Intervall möchten Sie bezahlen?' }}</app-label>
          <mat-form-field>
            <mat-select id="zahlungsart" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" [formControl]="zahlungsart" [compareWith]="lookupService.compareValues">
              <mat-option *ngFor="let za of zahlungsarten | async" [value]="za">{{ za.Value }}</mat-option>
            </mat-select>
            <mat-error *ngIf="zahlungsart.hasError('required')">{{ 'SELECTREQUIRED' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</form>
